export default __webpack_public_path__ + "static/media/abstract-wallpaper_23-2148663179.7362bac4.jpg";